// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {
    if (typeof tns === 'undefined') return;
  
    const sliders = new Map(); // Store slider instances by container element
    const heightObservers = new Map(); // Store MutationObservers for height equalization
  
    function equalizeHeights(container) {
      requestAnimationFrame(function () {
        const items = container.querySelectorAll('.tns-item');
        if (!items.length) return;

        container.style.removeProperty('--tns-item-height');

        requestAnimationFrame(function () {
          let maxHeight = 0;
          items.forEach(function (item) {
            const h = item.offsetHeight;
            if (h > maxHeight) maxHeight = h;
          });

          if (maxHeight > 0) {
            container.style.setProperty('--tns-item-height', maxHeight + 'px');
          }
        });
      });
    }
  
    function setupHeightObserver(container) {
      // Disconnect existing observer if any
      if (heightObservers.has(container)) {
        heightObservers.get(container).disconnect();
      }
  
      // Create observer to watch for .tns-item elements being added
      const observer = new MutationObserver(function (mutations) {
        let hasNewItems = false;
  
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('tns-item')) {
                hasNewItems = true;
              } else if (node.querySelector && node.querySelector('.tns-item')) {
                hasNewItems = true;
              }
            }
          });
        });
  
        // Equalize heights when new items are added
        if (hasNewItems) {
          equalizeHeights(container);
        }
      });
  
      // Observe the container for new child elements
      observer.observe(container, {
        childList: true,
        subtree: true
      });
  
      heightObservers.set(container, observer);
    }
  
    function initSliders() {
      if (window.innerWidth >= 1200) {
        destroyAllSliders();
        return;
      }
  
      const containers = document.querySelectorAll('.tns-slider-container');
      
      containers.forEach(function (container) {
        // Skip if already initialized
        if (sliders.has(container)) return;
        if (container.classList.contains('tns-slider')) return;

        try {
          // For logo-list and award-badges sections, use fixedWidth 200; otherwise 250
          const isLogoList = container.closest('.logo-list') !== null;
          const isAwardBadges = container.closest('.award-badges') !== null;

          const slider = tns({
            container: container,
            loop: true,
            gutter: 10,
            edgePadding: 50,
            items: 3,
            fixedWidth: (isLogoList || isAwardBadges) ? 200 : 250,
            center: true,
            controls: false,
            nav: false,
            mouseDrag: true,
            touch: true,
            responsive: {
              767: {
                items: 3,
                center: false,
                gutter: 20,
                fixedWidth: false,
                edgePadding: 0,
              },
              1024: {
                items: (isLogoList || isAwardBadges) ? 4 : 3,
                center: false,
                gutter: 20,
                fixedWidth: false,
                edgePadding: 0,
              },
            },
            onInit: function () {
              // Set up observer to watch for items and equalize heights instantly
              setupHeightObserver(container);
              // Equalize heights immediately after init
              equalizeHeights(container);
            },
            onIndexChanged: function () {
              equalizeHeights(container);
            },
          });
  
          sliders.set(container, slider);
  
          // Equalize heights on resize
          window.addEventListener('resize', function () {
            equalizeHeights(container);
          });
        } catch (error) {
          // Error initializing Tiny Slider instance
        }
      });
    }
  
    function destroyAllSliders() {
      sliders.forEach(function (slider, container) {
        try {
          slider.destroy();
        } catch (e) {
          // Ignore destroy errors
        }
        sliders.delete(container);
  
        // Disconnect height observer
        if (heightObservers.has(container)) {
          heightObservers.get(container).disconnect();
          heightObservers.delete(container);
        }
      });
    }
  
    // ============================
    // Industry Reviews & Info Cards
    // ============================
  
    function initReviewAndInfoSliders() {
      const containers = document.querySelectorAll('.industry-reviews__slider, .info-cards__grid');
      if (!containers.length) return;
  
      containers.forEach(function (container) {
        // Skip if already initialized
        if (container.classList.contains('tns-slider')) return;
  
        // Ensure there are child items
        const items = container.querySelectorAll('.slide, .industry-reviews__slide, .info-cards__item-wrapper');
        if (!items.length) return;
  
        try {
          const slider = tns({
            container: container,
            loop: true,
            gutter: 10,
            // Base config for mobile (< 600px): 1 slide with center
            items: 1,
            center: true,
            edgePadding: 60,
            controls: false,
            nav: false,
            mouseDrag: true,
            touch: true,
            speed: 500,
            slideBy: 1,
            responsive: {
              767: {
                items: 2,
                center: false,
                edgePadding: 0,
                gutter: 20,
                loop: true,
                slideBy: 1,
              },
              1024: {
                items: 3,
                center: false,
                edgePadding: 0,
                gutter: 20,
                loop: true,
                slideBy: 1,
              },
            },
            onInit: function () {
              // Set up observer to watch for items and equalize heights instantly
              setupHeightObserver(container);
              // Equalize heights immediately after init
              equalizeHeights(container);
  
              const images = container.querySelectorAll('img');
              images.forEach(function (img) {
                if (img.complete) {
                  equalizeHeights(container);
                } else {
                  img.addEventListener('load', function () {
                    equalizeHeights(container);
                  });
                  img.addEventListener('error', function () {
                    equalizeHeights(container);
                  });
                }
              });
            },
            onIndexChanged: function () {
              equalizeHeights(container);
            },
            onTransitionEnd: function () {
              equalizeHeights(container);
            },
          });
  
          window.addEventListener('resize', function () {
            equalizeHeights(container);
          });
        } catch (error) {
          // Error initializing shared slider for reviews/info-cards
        }
      });
    }
  
    // Initial run
    initSliders();
    initReviewAndInfoSliders();
  
    // Re-evaluate on resize for Instagram/Partners/Logo sliders only
    let resizeRequestId;
    window.addEventListener('resize', function () {
      if (resizeRequestId) {
        cancelAnimationFrame(resizeRequestId);
      }
      resizeRequestId = requestAnimationFrame(function () {
        if (window.innerWidth < 1200) {
          initSliders();
        } else {
          destroyAllSliders();
        }
      });
    });
  });
  